import React, { useState } from 'react';
import RnDUploadSection from './RnDUploadSection';
import RnDResultsSection from './RnDResultsSection';

const RnDPromptingContent = () => {
  const [extractedText, setExtractedText] = useState('');
  const [llmResponse, setLlmResponse] = useState('');
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [filesProcessed, setFilesProcessed] = useState(0);

  const handleProcessingComplete = (results) => {
    setExtractedText(results.extracted_text || '');
    setLlmResponse(results.llm_response || '');
    setFilesProcessed(results.files_processed || 0);
    setIsDataLoaded(true);
  };

  return (
    <main className="p-6">
      <RnDUploadSection onProcessingComplete={handleProcessingComplete} />
      <RnDResultsSection 
        extractedText={extractedText}
        llmResponse={llmResponse}
        filesProcessed={filesProcessed}
        isDataLoaded={isDataLoaded}
      />
    </main>
  );
};

export default RnDPromptingContent;
